import { render } from "./adminbreadcrumb.vue?vue&type=template&id=9acbe4b2"
import script from "./adminbreadcrumb.vue?vue&type=script&lang=js"
export * from "./adminbreadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__